import React, { useState } from 'react';
import './ProductCard.css';

const ProductCard = ({ name, description, image, price, oldPrice, soldOut = false }) => {
  const [isSoldOut] = useState(soldOut);
  const cardClassName = `product-card${isSoldOut ? ' product-card--sold-out' : ''}`;

  return (
    <div className={cardClassName}>
      <div className="product-image">
        <img src={image} alt={name} />
      </div>

      <div className="product-info">
        <h2 className="product-title">{name}</h2>
        <p className="product-description">{description}</p>

        <div className="product-price-section">
          <span className="current-price">{price}</span>
          <span className="old-price">{oldPrice}</span>
          <span className="spacer"></span>
          {!isSoldOut && <span className="discount-tag">OFERTA</span>}
        </div>

        <button className="add-to-cart-btn" disabled={isSoldOut}>
          {isSoldOut ? 'Esgotat' : 'Afegir a la cistella'}
        </button>
      </div>
    </div>
  );
};

export default ProductCard;
